import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import HeaderPortal from '../../../../components/layout/HeaderPortal';
import Portal from 'utils/portal/Portal';
import { withAreaGetter } from 'providers/AreasConsumers';
import { areas } from 'constants/areas';

import HeaderLinks from './header/HeaderLinks';
import ScoringCategoryListBrowser from './ScoringCategoryListBrowser';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_SCORING } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();

  const onAdd = () => {
    historyContext.push(`/scoringCategories/new`);
  };

  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_SCORING} withForbiddenPage={false}>
          <HeaderLinks onAdd={onAdd} />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_SCORING}>
        <ScoringCategoryListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
